import React from "react";
import { InputField } from "../Fields/InputField";
import { requiredField } from "../Validation";

export const ProductReferenceField = ( props ) => {
    return <InputField
        fieldId="productReference"
        fieldLabel={ "Reference of product for the " + props.elementType }
        fieldType="text"
        fieldRequired={ true }
        validator={ requiredField }
    />;
}